import { createAction, props } from '@ngrx/store';
import { DeleteReceiptInput, DeleteReceiptOutput, GetReceiptOutput, GetTransferOutput, ListReceiptFilesOutput, ListReceiptsOutput, ListTransfersOutput } from '@smash-sdk/transfer/ejs/01-2024';

export const loadTransfers = createAction(
  '[TransfersAdmin] Load Transfers'
);

export const loadTransfersSuccess = createAction(
  '[TransfersAdmin] Load Transfers Success',
  props<{ transfers: ListTransfersOutput['transfers'] & { team: string, receiversNumber: number, sender: string, receiverEmails: string, type: string }[] }>()
);

export const loadTransfersFailure = createAction(
  '[TransfersAdmin] Load Transfers Failure',
  props<{ error: any }>()
);

export const loadTransfer = createAction(
  '[TransferAdmin] Load Transfer',
  props<{ transferId: string }>()
);

export const loadTransferDetails = createAction(
  '[TransferAdmin] Load Transfer Details',
  props<{ transferId: string }>()
);

export const loadTransferDetailsSuccess = createAction(
  '[TransferAdmin] Load Transfer Details Success',
  props<{ transfer: GetTransferOutput['transfer'] & { delivery: { receivers: { email: string }[] } } }>()
);

export const loadTransferDetailsFailure = createAction(
  '[TransferAdmin] Load Transfer Details Failure',
  props<{ error: string }>()
);

export const loadTransferDetailsFiles = createAction(
  '[TransferAdmin] Load Transfer Details Files',
  props<{ transferId: string }>()
);

export const loadTransferDetailsFilesSuccess = createAction(
  '[TransferAdmin] Load Transfer Details Files Success',
  props<{ transferFiles: any[] }>()
);

export const loadTransferDetailsFilesFailure = createAction(
  '[TransferAdmin] Load Transfer Details Files Failure',
  props<{ error: string }>()
);

export const loadTransferEvents = createAction(
  '[TransferAdmin] Load Transfer Events',
  props<{ transferId: string }>()
);

export const loadTransferEventsSuccess = createAction(
  '[TransferAdmin] Load Transfer Events Success',
  props<{ events: any[], eventsGroupedByEmailArray: any[], eventsGroupedByAnonymousUserArray: any[] }>()
);

export const loadTransferEventsFailure = createAction(
  '[TransferAdmin] Load Transfer Events Failure',
  props<{ error: string }>()
);

export const deleteTransfer = createAction(
  '[TransferAdmin] Delete Transfer',
  props<{ transferId: string }>()
);

export const deleteTransferSuccess = createAction(
  '[TransferAdmin] Delete Transfer Success',
  props<{ transferId: string }>()
);

export const deleteTransferFailure = createAction(
  '[TransferAdmin] Delete Transfer Failure',
  props<{ error: string }>()
);

export const listTransfersReceived = createAction(
  '[TransfersAdmin] List Transfers Received'
);

export const listTransfersReceivedSuccess = createAction(
  '[TransfersAdmin] List Transfers Received Success',
  props<{ transfers: ListReceiptsOutput['receipts'] }>()
);

export const listTransfersReceivedFailure = createAction(
  '[TransfersAdmin] List Transfers Received Failure',
  props<{ error: any }>()
);

export const deleteTransferReceived = createAction(
  '[TransfersAdmin] Delete Transfer Received',
  props<{ receiptId: DeleteReceiptInput['receiptId'] }>()
);

export const deleteTransferReceivedSuccess = createAction(
  '[TransfersAdmin] Delete Transfer Received Success',
  props<{ receipt: DeleteReceiptOutput['receipt'] }>()
);

export const deleteTransferReceivedFailure = createAction(
  '[TransfersAdmin] Delete Transfer Received Failure',
  props<{ error: any }>()
);

export const getReceipt = createAction(
  '[TransfersAdmin] Get Receipt',
  props<{ receiptId: string }>()
);

export const getReceiptSuccess = createAction(
  '[TransfersAdmin] Get Receipt Success',
  props<{ receipt: GetReceiptOutput['receipt'] }>()
);

export const getReceiptFailure = createAction(
  '[TransfersAdmin] Get Receipt Failure',
  props<{ error: any }>()
);

export const listReceiptFiles = createAction(
  '[TransfersAdmin] List Receipt Files',
  props<{ receiptId: string }>()
);

export const listReceiptFilesSuccess = createAction(
  '[TransfersAdmin] List Receipt Files Success',
  props<{ files: ListReceiptFilesOutput['files'] }>()
);

export const listReceiptFilesFailure = createAction(
  '[TransfersAdmin] List Receipt Files Failure',
  props<{ error: any }>()
);

